export const checkDefaults = (asset) => {
  return Object.entries(asset).find((key) => key[0].endsWith("IsDefault") && key[1]) ? true : false;
};
